import { render } from "./PendingTable.vue?vue&type=template&id=6b5b838c"
import script from "./PendingTable.vue?vue&type=script&lang=js"
export * from "./PendingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__